/**
 * Подписи грида таймшита: дивизионы и короткий клиент.
 *
 * Клиент в диагональной шапке колонки не помещается никак — сокращаем до
 * АКРОНИМА по словам: «D. H. Griffin Contracting» → DHG, «Machinery
 * Installation Specialists» → MIS. Акроним стабилен (не зависит от того, где
 * обрезать) и различим: первые-3-буквы дали бы «D. », «Mac» — второе ещё
 * терпимо, первое бессмысленно. Для односложных имён акроним вырождается в
 * одну букву — там берём первые три: «TRUIST» → TRU.
 *
 * Дивизионы здесь — числовые коды (10, 35, 50…), их не сокращаем.
 */

/** Дивизион из карточки (employee и job хранят его одинаково). */
export function divisionOf(obj) {
    return String(obj?.Division ?? obj?.division ?? '').trim();
}

/**
 * Агентство temp'а. Дивизион (Temps.Division) теперь заведён у большинства
 * temp'ов, но не у всех, поэтому в строке листа агентство показывается всегда —
 * первыми тремя буквами: «Power Labor» → POW, «Red Moon» → RED.
 */
export function agencyOf(obj) {
    return String(obj?.Agency ?? obj?.agency ?? '').trim();
}

export function shortAgency(name) {
    return String(name || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase();
}

/** Клиент работы коротко: акроним по словам, максимум 3 буквы. */
export function shortCustomer(name) {
    const words = String(name || '').split(/[^A-Za-z0-9]+/).filter(Boolean);
    if (!words.length) return '';
    if (words.length === 1) return words[0].slice(0, 3).toUpperCase();

    return words.map(w => w[0]).join('').slice(0, 3).toUpperCase();
}

/**
 * Диагональная подпись работы ОДНОЙ строкой: «див·код·КЛИЕНТ» («35·8199·DHG»).
 * Порядок именно такой — дивизион, номер, клиент; одна строка ложится вдоль
 * всей диагонали, а две короткие строки друг под другом резались по краям.
 */
export function jobHeaderParts(job) {
    return {
        div: divisionOf(job),
        cust: shortCustomer(job?.Customer ?? job?.customer ?? ''),
    };
}

/**
 * Код работы в диагональ входит до 8 знаков. Длиннее бывают коды alternative
 * jobs («TRNG - NCCER», «xx-55-9998SC»): дивизиона у них нет, поэтому начало
 * кода встаёт мелко на его место, хвост — основным кеглем: «TRNG» / «NCCER».
 */
export function headerCodeParts(code, div = '') {
    const s = String(code ?? '').trim();
    const m = !div && s.length > 8 ? s.match(/^(.*?)[\s-]+([^\s-]+)$/) : null;
    return m ? { lead: m[1], main: m[2] } : { lead: '', main: s };
}
